import React from 'react';
import CoreComponent from './Core';

class Login extends CoreComponent {
  constructor(props){
    super(props);
    this.state={
        username:'',
        password:''
    };
  }
  componentDidMount(){
    document.body.className ="hold-transition login-page";
  }
  handleInputChange(e){
      const value =  e.target.value;
      const name = e.target.name;
      this.setState({
          [name]:value
      });
  }
  submit(event) {
    this.lockScreen();
    event.preventDefault();
    fetch("/api/organ/login/", {
          method: 'POST',
          body: JSON.stringify({
              user:{
                  "user": this.state.username,
                  "pass": this.state.password
              }}),
          headers: {
              'Content-Type': 'application/json'
          }
      })
      .then(res => res.json())
      .then(data => {
          if (data.status===1)
              window.location.href="/organ/dashboard/";
          else{
              this.showToast('اطلاعات وارد شده معتبر نمی باشد.','warning');
          }
          this.unLockScreen();
      });
  }
  render(){
      return (
        <div className="login-box">
          <div className="login-logo">
            <p>درگاه مدیریت سازمان ها و مراکز علمی در <b>سیویلیکا </b></p>
          </div>
          <div className="login-box-body">
            <form onSubmit={this.handleSubmit} method="post">
                <div className="form-group has-feedback">
                    <input onChange={e=>this.handleInputChange(e)} type="text" name="username" className="form-control" placeholder="نام کاربری" />
                    <span className="glyphicon glyphicon-envelope form-control-feedback"></span>
                </div>
                <div className="form-group has-feedback">
                    <input onChange={e=>this.handleInputChange(e)} type="password" name="password" className="form-control" placeholder="کلمه عبور" />
                    <span className="glyphicon glyphicon-lock form-control-feedback"></span>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        <button type="submit" onClick={e=>this.submit(e)} className="btn btn-primary btn-block btn-flat">ورود</button>
                    </div>
                </div>
            </form>
          </div>
          <div className="login-footer">
              <a href="https://civilica.com/">صفحه نخست سایت</a>
          </div>
        </div>
      );
  }
}
export default Login;